import { forwardRef, createElement } from 'react';
import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import styles from '../styles/Input.module.scss';
import InputWrapper from './InputWrapper.js';

var Input = function (_a, ref) {
    var className = _a.className, error = _a.error, helperText = _a.helperText, type = _a.type, hasFocusIndicator = _a.hasFocusIndicator, inputProps = __rest(_a, ["className", "error", "helperText", "type", "hasFocusIndicator"]);
    return (createElement(InputWrapper, { className: className, error: error, hasFocusIndicator: hasFocusIndicator, helperText: helperText, inputType: type }, function (_a) {
        var inputType = _a.inputType;
        return (createElement("input", __assign({ className: styles.input, ref: ref, type: inputType }, inputProps)));
    }));
};
var Input$1 = forwardRef(Input);

export default Input$1;
